import React from 'react';
import PropTypes from 'prop-types';

const Pagination = ({ goToPage, show, countPages, page, pages, showStart, showEnd, backgroundColor }) => (
  <React.Fragment> {show && (
    <ul className={`invoicenavlist ${backgroundColor || 'invoicenavlistgreen'}`}>
      { showStart && (
        <React.Fragment>
          <li className="page-item">
            <button className="page-link" onClick={() => { goToPage(0); }}>1</button>
          </li>
          <li className="page-item">
            <div className="page-dots">...</div>
          </li>
        </React.Fragment>
      )}
      {pages.map(pageIndex => (
        <li key={pageIndex} className={`page-item ${pageIndex === page ? backgroundColor ? 'tc' : 'active' : ''}`} onClick={() => { goToPage(pageIndex); }}>
          <button className="page-link">{pageIndex + 1}</button>
        </li>
      ))}
      { showEnd && (
        <React.Fragment>
          <li className="page-item">
            <div className="page-dots">...</div>
          </li>
          <li className="page-item">
            <button className="page-link" onClick={() => { goToPage(countPages - 1); }}>{countPages}</button>
          </li>
        </React.Fragment>
      )}
    </ul>
  )}
  </React.Fragment>
);

Pagination.propTypes = {
  show: PropTypes.bool.isRequired,
  pages: PropTypes.arrayOf(PropTypes.number).isRequired,
  goToPage: PropTypes.func.isRequired,
  // count: PropTypes.number.isRequired,
  // pageSize: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  countPages: PropTypes.number.isRequired,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.jsx